import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import StandartTemplate from "@/components/Template/StandartTemplate.vue";
import PageHeader from "@/components/UI/PageHeader.vue";
import ApiEnter from "@/api/ApiEnter";
import ApiNexiCharge from "@/api/ApiNexiCharge";
import DataNexiCharge from "@/data/NexiCharge/DataNexiCharge";
import { chargeStatusColor, chargeStatusText, csvReasonText, errorMessage, formatAmount, formatDate } from "@/util/NexiCharge/NexiChargeDisplay";
import sweetalert from "sweetalert";
let NexiChargeNew = class NexiChargeNew extends Vue {
    constructor() {
        super(...arguments);
        this.Breadcrumbs = DataNexiCharge.BreadcrumbsNew;
        this.EligibleOrders = [];
        this.SelectedRows = [];
        this.SelectedOrderProductUuid = null;
        this.CsvFile = null;
        this.CsvDialog = false;
        this.CsvResult = null;
        this.SendDialog = false;
        this.SendResults = [];
        this.HasLoadingOrders = false;
        this.HasImporting = false;
        this.HasSaving = false;
        this.HasSending = false;
        this.ChargeStatusColor = chargeStatusColor;
        this.ChargeStatusText = chargeStatusText;
        this.CsvReasonText = csvReasonText;
        this.FormatAmount = formatAmount;
    }
    // SIM eleggibili non ancora presenti in bozza, con label per la ricerca (subsid, SIM o ordine)
    get AvailableOrders() {
        const usedUuids = this.SelectedRows.map((r) => r.order_product_uuid);
        return this.EligibleOrders
            .filter((o) => !usedUuids.includes(o.order_product_uuid))
            .map((o) => ({ ...o, label: this.BuildLabel(o) }));
    }
    BuildLabel(o) {
        const amount = "€" + Number(o.amount).toFixed(2).replace(".", ",");
        const subsid = o.subsid !== null && o.subsid !== undefined ? o.subsid : "—";
        return `#${o.order_id} — SIM ${o.order_product_id} — subsid ${subsid} — ${o.customer_name} — ${amount} — ${formatDate(o.create_at).split(" ")[0]}`;
    }
    get Total() {
        return this.SelectedRows.reduce((sum, r) => {
            const num = Number(r.amount);
            return sum + (isNaN(num) ? 0 : num);
        }, 0);
    }
    OnSelectOrder(orderProductUuid) {
        if (!orderProductUuid) {
            return;
        }
        const order = this.EligibleOrders.find((o) => o.order_product_uuid === orderProductUuid);
        if (order && !this.SelectedRows.some((r) => r.order_product_uuid === orderProductUuid)) {
            this.SelectedRows.push({
                order_uuid: order.order_uuid,
                order_id: order.order_id,
                order_product_uuid: order.order_product_uuid,
                order_product_id: order.order_product_id,
                subsid: order.subsid,
                customer_name: order.customer_name,
                nexi_contract_id: order.nexi_contract_id,
                amount: Number(order.amount).toFixed(2),
            });
        }
        this.$nextTick(() => {
            this.SelectedOrderProductUuid = null;
        });
    }
    RemoveRow(index) {
        this.SelectedRows.splice(index, 1);
    }
    // Mantiene massimo 2 decimali e impedisce valori non numerici
    SanitizeAmount(index) {
        const row = this.SelectedRows[index];
        if (!row) {
            return;
        }
        let value = String(row.amount).replace(",", ".").replace(/[^0-9.]/g, "");
        const dotIndex = value.indexOf(".");
        if (dotIndex !== -1) {
            value = value.slice(0, dotIndex + 1) + value.slice(dotIndex + 1).replace(/\./g, "").slice(0, 2);
        }
        row.amount = value;
    }
    AmountError(amount) {
        const num = Number(amount);
        if (amount === "" || amount === null || isNaN(num) || num <= 0) {
            return this.$t("nexi_charge.invalid_amount");
        }
        return "";
    }
    get CanSave() {
        if (!this.SelectedRows.length) {
            return false;
        }
        return this.SelectedRows.every((r) => {
            const num = Number(r.amount);
            return r.amount !== "" && !isNaN(num) && num > 0;
        });
    }
    // Il salvataggio è consentito anche a bozza vuota (persiste lo svuotamento);
    // con righe presenti, gli importi devono essere validi.
    get CanSaveDraft() {
        return this.SelectedRows.length === 0 || this.CanSave;
    }
    BuildRows() {
        return this.SelectedRows.map((r) => ({
            order_product_uuid: r.order_product_uuid,
            amount: Number(Number(r.amount).toFixed(2)),
        }));
    }
    MapDraftRows(rows) {
        return rows.map((r) => ({
            order_uuid: r.order_uuid,
            order_id: r.order_id,
            order_product_uuid: r.order_product_uuid,
            order_product_id: r.order_product_id,
            subsid: r.subsid,
            customer_name: r.customer_name,
            nexi_contract_id: r.nexi_contract_id,
            amount: Number(r.amount).toFixed(2),
        }));
    }
    async OnSaveDraft() {
        this.HasSaving = true;
        try {
            // Bozza vuota → il backend rifiuta un save senza righe (nexi_no_rows):
            // lo svuotamento si persiste con DeleteDraft (stato finale = bozza vuota).
            if (!this.SelectedRows.length) {
                await ApiNexiCharge.DeleteDraft(ApiEnter.CurrentSessionUUID);
            }
            else {
                await ApiNexiCharge.SaveDraft(ApiEnter.CurrentSessionUUID, this.BuildRows());
            }
            await sweetalert({
                title: this.$t("general.success"),
                text: this.$t("nexi_charge.save_success"),
                icon: "success",
            });
            await this.ReloadDraft();
        }
        catch (e) {
            this.ShowError(e);
        }
        this.HasSaving = false;
    }
    // Apre l'ordine della riga; salva prima la bozza così non si perdono le righe correnti.
    async OnOpenOrder(row) {
        if (this.SelectedRows.length && !this.CanSave) {
            sweetalert({
                title: this.$t("general.error"),
                text: this.$t("nexi_charge.fix_amounts_before_continue"),
                icon: "error",
            });
            return;
        }
        this.HasSaving = true;
        try {
            if (this.SelectedRows.length) {
                await ApiNexiCharge.SaveDraft(ApiEnter.CurrentSessionUUID, this.BuildRows());
            }
            this.$router.push("/shop/orders/view/" + row.order_uuid);
        }
        catch (e) {
            this.ShowError(e);
            this.HasSaving = false;
        }
    }
    async OnCancelDraft() {
        const confirmed = await sweetalert({
            title: this.$t("general.confirm"),
            text: this.$t("nexi_charge.confirm_cancel"),
            icon: "warning",
            buttons: [this.$t("general.no"), this.$t("general.yes")],
        });
        if (!confirmed) {
            return;
        }
        this.HasSaving = true;
        try {
            await ApiNexiCharge.DeleteDraft(ApiEnter.CurrentSessionUUID);
            this.SelectedRows = [];
        }
        catch (e) {
            this.ShowError(e);
        }
        this.HasSaving = false;
    }
    async OnImportCsv() {
        if (!this.CsvFile) {
            return;
        }
        // Persistiamo prima le righe inserite manualmente per non perderle al reload della bozza.
        if (this.SelectedRows.length && !this.CanSave) {
            sweetalert({
                title: this.$t("general.error"),
                text: this.$t("nexi_charge.fix_amounts_before_import"),
                icon: "error",
            });
            return;
        }
        this.HasImporting = true;
        try {
            if (this.SelectedRows.length) {
                await ApiNexiCharge.SaveDraft(ApiEnter.CurrentSessionUUID, this.BuildRows());
            }
            this.CsvResult = await ApiNexiCharge.ImportCsv(ApiEnter.CurrentSessionUUID, this.CsvFile);
            this.CsvFile = null;
            await this.ReloadDraft();
            this.CsvDialog = true;
        }
        catch (e) {
            this.ShowError(e);
        }
        this.HasImporting = false;
    }
    async OnSend() {
        const confirmed = await sweetalert({
            title: this.$t("general.confirm"),
            text: this.$t("nexi_charge.confirm_send"),
            icon: "warning",
            buttons: [this.$t("general.no"), this.$t("general.yes")],
        });
        if (!confirmed) {
            return;
        }
        this.HasSending = true;
        try {
            // La bozza persistita deve riflettere la UI prima dell'invio sincrono.
            await ApiNexiCharge.SaveDraft(ApiEnter.CurrentSessionUUID, this.BuildRows());
            const result = await ApiNexiCharge.SendDraft(ApiEnter.CurrentSessionUUID);
            this.SendResults = result.results;
            this.SelectedRows = [];
            this.SendDialog = true;
        }
        catch (e) {
            this.ShowError(e);
        }
        this.HasSending = false;
    }
    OnCloseSendDialog() {
        this.SendDialog = false;
        this.$router.push("/shop/nexi-addebiti");
    }
    ShowError(e) {
        sweetalert({
            title: this.$t("general.error"),
            text: errorMessage(e && e.code),
            icon: "error",
        });
    }
    async ReloadDraft() {
        const draft = await ApiNexiCharge.GetDraft(ApiEnter.CurrentSessionUUID);
        this.SelectedRows = this.MapDraftRows(draft);
    }
    async LoadData() {
        const session = ApiEnter.CurrentSessionUUID;
        this.HasLoadingOrders = true;
        try {
            const [eligible, draft] = await Promise.all([
                ApiNexiCharge.GetEligibleOrders(session, {}),
                ApiNexiCharge.GetDraft(session),
            ]);
            this.EligibleOrders = eligible;
            this.SelectedRows = this.MapDraftRows(draft);
        }
        catch (e) {
            this.ShowError(e);
        }
        this.HasLoadingOrders = false;
    }
    mounted() {
        this.LoadData();
    }
};
NexiChargeNew = __decorate([
    Component({
        components: { StandartTemplate, PageHeader },
    })
], NexiChargeNew);
export default NexiChargeNew;
